import { render, staticRenderFns } from "./jymc_file.vue?vue&type=template&id=0941c976&scoped=true"
import script from "./jymc_file.vue?vue&type=script&lang=js"
export * from "./jymc_file.vue?vue&type=script&lang=js"
import style0 from "./jymc_file.vue?vue&type=style&index=0&id=0941c976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0941c976",
  null
  
)

export default component.exports